// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}

/*
! tailwindcss v3.4.13 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: "";
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
  tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type=button]),
input:where([type=reset]),
input:where([type=submit]) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/
button,
[role=button] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

.\\!container {
  width: 100% !important;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .\\!container {
    max-width: 640px !important;
  }
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .\\!container {
    max-width: 768px !important;
  }
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .\\!container {
    max-width: 1024px !important;
  }
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .\\!container {
    max-width: 1280px !important;
  }
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .\\!container {
    max-width: 1536px !important;
  }
  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.\\!absolute {
  position: absolute !important;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-0 {
  inset: 0px;
}

.bottom-0 {
  bottom: 0px;
}

.bottom-5 {
  bottom: 1.25rem;
}

.bottom-\\[-20px\\] {
  bottom: -20px;
}

.bottom-\\[-25px\\] {
  bottom: -25px;
}

.bottom-\\[-60\\%\\] {
  bottom: -60%;
}

.bottom-\\[-70\\%\\] {
  bottom: -70%;
}

.bottom-\\[-80\\%\\] {
  bottom: -80%;
}

.bottom-\\[1\\.5rem\\] {
  bottom: 1.5rem;
}

.bottom-\\[250px\\] {
  bottom: 250px;
}

.left-0 {
  left: 0px;
}

.left-\\[-10px\\] {
  left: -10px;
}

.left-\\[-5px\\] {
  left: -5px;
}

.left-\\[-8px\\] {
  left: -8px;
}

.left-\\[0\\%\\] {
  left: 0%;
}

.left-\\[10\\%\\] {
  left: 10%;
}

.left-\\[130px\\] {
  left: 130px;
}

.left-\\[150px\\] {
  left: 150px;
}

.left-\\[20\\%\\] {
  left: 20%;
}

.right-0 {
  right: 0px;
}

.right-5 {
  right: 1.25rem;
}

.right-\\[-8px\\] {
  right: -8px;
}

.right-\\[0\\.5rem\\] {
  right: 0.5rem;
}

.right-\\[10px\\] {
  right: 10px;
}

.right-\\[200px\\] {
  right: 200px;
}

.right-\\[5px\\] {
  right: 5px;
}

.top-0 {
  top: 0px;
}

.top-\\[-10px\\] {
  top: -10px;
}

.top-\\[-20px\\] {
  top: -20px;
}

.top-\\[-5px\\] {
  top: -5px;
}

.top-\\[-60px\\] {
  top: -60px;
}

.top-\\[-8px\\] {
  top: -8px;
}

.top-\\[0\\.5rem\\] {
  top: 0.5rem;
}

.top-\\[10\\%\\] {
  top: 10%;
}

.top-\\[100px\\] {
  top: 100px;
}

.top-\\[10px\\] {
  top: 10px;
}

.top-\\[110\\%\\] {
  top: 110%;
}

.top-\\[20px\\] {
  top: 20px;
}

.top-\\[40px\\] {
  top: 40px;
}

.top-\\[5px\\] {
  top: 5px;
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-\\[0\\] {
  z-index: 0;
}

.z-\\[10\\] {
  z-index: 10;
}

.z-\\[1\\] {
  z-index: 1;
}

.z-\\[2\\] {
  z-index: 2;
}

.z-\\[999\\] {
  z-index: 999;
}

.z-\\[99\\] {
  z-index: 99;
}

.m-2\\.5 {
  margin: 0.625rem;
}

.m-3 {
  margin: 0.75rem;
}

.m-\\[10px\\] {
  margin: 10px;
}

.m-\\[15px\\] {
  margin: 15px;
}

.m-\\[20px\\] {
  margin: 20px;
}

.m-\\[5px\\] {
  margin: 5px;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-\\[10px\\] {
  margin-left: 10px;
  margin-right: 10px;
}

.mx-\\[15px\\] {
  margin-left: 15px;
  margin-right: 15px;
}

.mx-\\[1rem\\] {
  margin-left: 1rem;
  margin-right: 1rem;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}

.my-\\[15px\\] {
  margin-top: 15px;
  margin-bottom: 15px;
}

.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.\\!mb-\\[5px\\] {
  margin-bottom: 5px !important;
}

.\\!ml-0 {
  margin-left: 0px !important;
}

.\\!mr-\\[10px\\] {
  margin-right: 10px !important;
}

.\\!mt-0 {
  margin-top: 0px !important;
}

.-mb-3\\.5 {
  margin-bottom: -0.875rem;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-\\[10px\\] {
  margin-bottom: 10px;
}

.mb-\\[15px\\] {
  margin-bottom: 15px;
}

.mb-\\[20px\\] {
  margin-bottom: 20px;
}

.mb-\\[40px\\] {
  margin-bottom: 40px;
}

.me-2 {
  margin-inline-end: 0.5rem;
}

.ml-\\[40px\\] {
  margin-left: 40px;
}

.ml-\\[5px\\] {
  margin-left: 5px;
}

.mr-14 {
  margin-right: 3.5rem;
}

.mr-\\[10px\\] {
  margin-right: 10px;
}

.mr-\\[5px\\] {
  margin-right: 5px;
}

.mt-0 {
  margin-top: 0px;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-1\\.5 {
  margin-top: 0.375rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-2\\.5 {
  margin-top: 0.625rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-7 {
  margin-top: 1.75rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-\\[10px\\] {
  margin-top: 10px;
}

.mt-\\[20px\\] {
  margin-top: 20px;
}

.mt-\\[30px\\] {
  margin-top: 30px;
}

.block {
  display: block;
}

.\\!flex {
  display: flex !important;
}

.flex {
  display: flex;
}

.table {
  display: table;
}

.hidden {
  display: none;
}

.aspect-\\[0\\.924\\] {
  aspect-ratio: 0.924;
}

.aspect-\\[0\\.97\\] {
  aspect-ratio: 0.97;
}

.aspect-\\[1\\.02\\] {
  aspect-ratio: 1.02;
}

.aspect-\\[1\\.03\\] {
  aspect-ratio: 1.03;
}

.aspect-\\[1\\.161\\] {
  aspect-ratio: 1.161;
}

.aspect-\\[1\\.81\\] {
  aspect-ratio: 1.81;
}

.aspect-\\[1\\.871\\] {
  aspect-ratio: 1.871;
}

.aspect-\\[1\\/2\\] {
  aspect-ratio: 1/2;
}

.aspect-\\[3\\.44\\] {
  aspect-ratio: 3.44;
}

.aspect-\\[3\\.69\\] {
  aspect-ratio: 3.69;
}

.aspect-\\[5\\.52\\] {
  aspect-ratio: 5.52;
}

.aspect-square {
  aspect-ratio: 1/1;
}

.size-\\[150px\\] {
  width: 150px;
  height: 150px;
}

.size-\\[40px\\] {
  width: 40px;
  height: 40px;
}

.size-\\[50px\\] {
  width: 50px;
  height: 50px;
}

.size-full {
  width: 100%;
  height: 100%;
}

.h-0\\.5 {
  height: 0.125rem;
}

.h-3 {
  height: 0.75rem;
}

.h-\\[100dvh\\] {
  height: 100dvh;
}

.h-\\[100px\\] {
  height: 100px;
}

.h-\\[100vh\\] {
  height: 100vh;
}

.h-\\[10px\\] {
  height: 10px;
}

.h-\\[150px\\] {
  height: 150px;
}

.h-\\[16px\\] {
  height: 16px;
}

.h-\\[1px\\] {
  height: 1px;
}

.h-\\[25px\\] {
  height: 25px;
}

.h-\\[320px\\] {
  height: 320px;
}

.h-\\[32px\\] {
  height: 32px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-\\[500\\%\\] {
  height: 500%;
}

.h-\\[500px\\] {
  height: 500px;
}

.h-\\[50px\\] {
  height: 50px;
}

.h-\\[70\\%\\] {
  height: 70%;
}

.h-\\[700px\\] {
  height: 700px;
}

.h-\\[70px\\] {
  height: 70px;
}

.h-\\[70vh\\] {
  height: 70vh;
}

.h-\\[75vh\\] {
  height: 75vh;
}

.h-\\[800px\\] {
  height: 800px;
}

.h-\\[90\\%\\] {
  height: 90%;
}

.h-auto {
  height: auto;
}

.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}

.h-full {
  height: 100%;
}

.h-screen {
  height: 100vh;
}

.max-h-\\[500px\\] {
  max-height: 500px;
}

.max-h-\\[700px\\] {
  max-height: 700px;
}

.min-h-\\[141px\\] {
  min-height: 141px;
}

.min-h-\\[179px\\] {
  min-height: 179px;
}

.min-h-\\[200px\\] {
  min-height: 200px;
}

.min-h-\\[248px\\] {
  min-height: 248px;
}

.min-h-\\[660px\\] {
  min-height: 660px;
}

.\\!w-\\[20px\\] {
  width: 20px !important;
}

.w-10 {
  width: 2.5rem;
}

.w-\\[100\\%\\] {
  width: 100%;
}

.w-\\[100px\\] {
  width: 100px;
}

.w-\\[10rem\\] {
  width: 10rem;
}

.w-\\[125px\\] {
  width: 125px;
}

.w-\\[134px\\] {
  width: 134px;
}

.w-\\[150px\\] {
  width: 150px;
}

.w-\\[16px\\] {
  width: 16px;
}

.w-\\[20\\%\\] {
  width: 20%;
}

.w-\\[200px\\] {
  width: 200px;
}

.w-\\[240px\\] {
  width: 240px;
}

.w-\\[242px\\] {
  width: 242px;
}

.w-\\[25px\\] {
  width: 25px;
}

.w-\\[300px\\] {
  width: 300px;
}

.w-\\[330px\\] {
  width: 330px;
}

.w-\\[332px\\] {
  width: 332px;
}

.w-\\[345px\\] {
  width: 345px;
}

.w-\\[34px\\] {
  width: 34px;
}

.w-\\[354px\\] {
  width: 354px;
}

.w-\\[35px\\] {
  width: 35px;
}

.w-\\[37px\\] {
  width: 37px;
}

.w-\\[38\\.95vh\\] {
  width: 38.95vh;
}

.w-\\[38px\\] {
  width: 38px;
}

.w-\\[40\\%\\] {
  width: 40%;
}

.w-\\[40px\\] {
  width: 40px;
}

.w-\\[41px\\] {
  width: 41px;
}

.w-\\[45px\\] {
  width: 45px;
}

.w-\\[46px\\] {
  width: 46px;
}

.w-\\[50\\%\\] {
  width: 50%;
}

.w-\\[50px\\] {
  width: 50px;
}

.w-\\[60\\%\\] {
  width: 60%;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[60vw\\] {
  width: 60vw;
}

.w-\\[80\\%\\] {
  width: 80%;
}

.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}

.w-full {
  width: 100%;
}

.w-screen {
  width: 100vw;
}

.min-w-\\[70\\%\\] {
  min-width: 70%;
}

.max-w-\\[1000px\\] {
  max-width: 1000px;
}

.max-w-\\[1020px\\] {
  max-width: 1020px;
}

.max-w-\\[1500px\\] {
  max-width: 1500px;
}

.max-w-\\[300px\\] {
  max-width: 300px;
}

.max-w-\\[324px\\] {
  max-width: 324px;
}

.max-w-\\[330px\\] {
  max-width: 330px;
}

.max-w-\\[354px\\] {
  max-width: 354px;
}

.max-w-\\[362px\\] {
  max-width: 362px;
}

.max-w-\\[375px\\] {
  max-width: 375px;
}

.max-w-\\[381px\\] {
  max-width: 381px;
}

.max-w-\\[400px\\] {
  max-width: 400px;
}

.max-w-\\[414px\\] {
  max-width: 414px;
}

.max-w-\\[430px\\] {
  max-width: 430px;
}

.max-w-\\[455px\\] {
  max-width: 455px;
}

.max-w-\\[500px\\] {
  max-width: 500px;
}

.max-w-\\[600px\\] {
  max-width: 600px;
}

.max-w-\\[700px\\] {
  max-width: 700px;
}

.max-w-\\[800px\\] {
  max-width: 800px;
}

.max-w-\\[90\\%\\] {
  max-width: 90%;
}

.max-w-full {
  max-width: 100%;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-\\[2\\] {
  flex: 2;
}

.flex-shrink {
  flex-shrink: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.grow {
  flex-grow: 1;
}

.basis-0 {
  flex-basis: 0px;
}

.basis-auto {
  flex-basis: auto;
}

.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.resize {
  resize: both;
}

.appearance-none {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.content-center {
  align-content: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-evenly {
  justify-content: space-evenly;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-3\\.5 {
  gap: 0.875rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-7 {
  gap: 1.75rem;
}

.gap-8 {
  gap: 2rem;
}

.gap-9 {
  gap: 2.25rem;
}

.gap-\\[10px\\] {
  gap: 10px;
}

.gap-\\[20px\\] {
  gap: 20px;
}

.self-center {
  align-self: center;
}

.self-stretch {
  align-self: stretch;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.text-ellipsis {
  text-overflow: ellipsis;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-\\[10px\\] {
  border-radius: 10px;
}

.rounded-\\[20px\\] {
  border-radius: 20px;
}

.rounded-\\[25px\\] {
  border-radius: 25px;
}

.rounded-\\[29px\\] {
  border-radius: 29px;
}

.rounded-\\[2rem\\] {
  border-radius: 2rem;
}

.rounded-\\[30px\\] {
  border-radius: 30px;
}

.rounded-\\[40px\\] {
  border-radius: 40px;
}

.rounded-\\[50\\%\\] {
  border-radius: 50%;
}

.rounded-\\[50px\\] {
  border-radius: 50px;
}

.rounded-\\[85px\\] {
  border-radius: 85px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-none {
  border-radius: 0px;
}

.rounded-sm {
  border-radius: 0.125rem;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}

.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-\\[1px\\] {
  border-width: 1px;
}

.border-\\[2px\\] {
  border-width: 2px;
}

.border-\\[3px\\] {
  border-width: 3px;
}

.border-\\[4px\\] {
  border-width: 4px;
}

.border-\\[5px\\] {
  border-width: 5px;
}

.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}

.border-solid {
  border-style: solid;
}

.border-dashed {
  border-style: dashed;
}

.border-none {
  border-style: none;
}

.border-\\[\\#ec4899\\] {
  --tw-border-opacity: 1;
  border-color: rgb(236, 72, 153, var(--tw-border-opacity));
}

.border-\\[\\#f0f0f0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240, 240, 240, var(--tw-border-opacity));
}

.border-\\[\\#f472b6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244, 114, 182, var(--tw-border-opacity));
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0, 0, 0, var(--tw-border-opacity));
}

.border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253, 164, 175, var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255, 255, 255, var(--tw-border-opacity));
}

.border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255, 255, 255, var(--tw-border-opacity));
}

.\\!bg-\\[\\#f0f0f0\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240, 240, 240, var(--tw-bg-opacity)) !important;
}

.bg-\\[\\#111113\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17, 17, 19, var(--tw-bg-opacity));
}

.bg-\\[\\#5eb2e5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(94, 178, 229, var(--tw-bg-opacity));
}

.bg-\\[\\#89e6c9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(137, 230, 201, var(--tw-bg-opacity));
}

.bg-\\[\\#c3e676\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(195, 230, 118, var(--tw-bg-opacity));
}

.bg-\\[\\#d4d4d4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212, 212, 212, var(--tw-bg-opacity));
}

.bg-\\[\\#d9ad89\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217, 173, 137, var(--tw-bg-opacity));
}

.bg-\\[\\#f0f0f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240, 240, 240, var(--tw-bg-opacity));
}

.bg-\\[\\#f0f0f0f0\\] {
  background-color: rgba(240, 240, 240, 0.9411764706);
}

.bg-\\[\\#f3effb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243, 239, 251, var(--tw-bg-opacity));
}

.bg-\\[\\#f5f5f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245, 245, 247, var(--tw-bg-opacity));
}

.bg-\\[\\#f6cdd2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246, 205, 210, var(--tw-bg-opacity));
}

.bg-\\[\\#fee0e0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254, 224, 224, var(--tw-bg-opacity));
}

.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255, 255, 255, var(--tw-bg-opacity));
}

.bg-\\[--apple\\] {
  background-color: var(--apple);
}

.bg-\\[--primary\\] {
  background-color: var(--primary);
}

.bg-\\[red\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255, 0, 0, var(--tw-bg-opacity));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0, 0, 0, var(--tw-bg-opacity));
}

.bg-fuchsia-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(240, 171, 252, var(--tw-bg-opacity));
}

.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129, 140, 248, var(--tw-bg-opacity));
}

.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251, 146, 60, var(--tw-bg-opacity));
}

.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234, 88, 12, var(--tw-bg-opacity));
}

.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236, 72, 153, var(--tw-bg-opacity));
}

.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248, 113, 113, var(--tw-bg-opacity));
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239, 68, 68, var(--tw-bg-opacity));
}

.bg-red-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(127, 29, 29, var(--tw-bg-opacity));
}

.bg-rose-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253, 164, 175, var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255, 255, 255, var(--tw-bg-opacity));
}

.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254, 249, 195, var(--tw-bg-opacity));
}

.bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39, 39, 42, var(--tw-bg-opacity));
}

.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}

.bg-\\[linear-gradient\\(269deg\\,\\#FFDBFF_0\\.77\\%\\,\\#B1C6FE_99\\.23\\%\\)\\] {
  background-image: linear-gradient(269deg, #FFDBFF 0.77%, #B1C6FE 99.23%);
}

.bg-\\[linear-gradient\\(to_right\\,_hsl\\(0\\,_100\\%\\,_50\\%\\)\\,_hsl\\(60\\,_100\\%\\,_50\\%\\)\\,_hsl\\(120\\,_100\\%\\,_50\\%\\)\\,_hsl\\(180\\,_100\\%\\,_50\\%\\)\\,_hsl\\(240\\,_100\\%\\,_50\\%\\)\\,_hsl\\(300\\,_100\\%\\,_50\\%\\)\\,_hsl\\(360\\,_100\\%\\,_50\\%\\)\\)\\] {
  background-image: linear-gradient(to right, hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%), hsl(180, 100%, 50%), hsl(240, 100%, 50%), hsl(300, 100%, 50%), hsl(0, 100%, 50%));
}

.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.from-\\[\\#C8F8FF\\] {
  --tw-gradient-from: #C8F8FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(200 248 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-pink-400 {
  --tw-gradient-from: #f472b6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.via-pink-500 {
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.to-\\[\\#FFD18C\\] {
  --tw-gradient-to: #FFD18C var(--tw-gradient-to-position);
}

.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}

.to-pink-600 {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}

.object-contain {
  -o-object-fit: contain;
  object-fit: contain;
}

.object-cover {
  -o-object-fit: cover;
  object-fit: cover;
}

.p-0 {
  padding: 0px;
}

.p-1 {
  padding: 0.25rem;
}

.p-1\\.5 {
  padding: 0.375rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-\\[10px\\] {
  padding: 10px;
}

.p-\\[15px\\] {
  padding: 15px;
}

.p-\\[20px\\] {
  padding: 20px;
}

.p-\\[2px\\] {
  padding: 2px;
}

.p-\\[2rem\\] {
  padding: 2rem;
}

.p-\\[30px\\] {
  padding: 30px;
}

.p-\\[3px\\] {
  padding: 3px;
}

.p-\\[40px\\] {
  padding: 40px;
}

.p-\\[50px\\] {
  padding: 50px;
}

.p-\\[5px\\] {
  padding: 5px;
}

.p-\\[6px\\] {
  padding: 6px;
}

.p-\\[8px\\] {
  padding: 8px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}

.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}

.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}

.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}

.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}

.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}

.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}

.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}

.pb-16 {
  padding-bottom: 4rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pb-5 {
  padding-bottom: 1.25rem;
}

.pl-20 {
  padding-left: 5rem;
}

.pl-\\[15px\\] {
  padding-left: 15px;
}

.pr-5 {
  padding-right: 1.25rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pt-11 {
  padding-top: 2.75rem;
}

.pt-12 {
  padding-top: 3rem;
}

.pt-2\\.5 {
  padding-top: 0.625rem;
}

.pt-20 {
  padding-top: 5rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pt-\\[15px\\] {
  padding-top: 15px;
}

.pt-\\[25px\\] {
  padding-top: 25px;
}

.text-center {
  text-align: center;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-5xl {
  font-size: 3rem;
  line-height: 1;
}

.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}

.text-\\[10px\\] {
  font-size: 10px;
}

.text-\\[12px\\] {
  font-size: 12px;
}

.text-\\[13px\\] {
  font-size: 13px;
}

.text-\\[15px\\] {
  font-size: 15px;
}

.text-\\[16px\\] {
  font-size: 16px;
}

.text-\\[20px\\] {
  font-size: 20px;
}

.text-\\[24px\\] {
  font-size: 24px;
}

.text-\\[25px\\] {
  font-size: 25px;
}

.text-\\[30px\\] {
  font-size: 30px;
}

.text-\\[32px\\] {
  font-size: 32px;
}

.text-\\[40px\\] {
  font-size: 40px;
}

.text-\\[50px\\] {
  font-size: 50px;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-black {
  font-weight: 900;
}

.font-bold {
  font-weight: 700;
}

.font-extrabold {
  font-weight: 800;
}

.font-extralight {
  font-weight: 200;
}

.font-light {
  font-weight: 300;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.italic {
  font-style: italic;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-none {
  line-height: 1;
}

.tracking-wider {
  letter-spacing: 0.05em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgb(255, 0, 0, var(--tw-text-opacity));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0, 0, 0, var(--tw-text-opacity));
}

.text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244, 114, 182, var(--tw-text-opacity));
}

.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236, 72, 153, var(--tw-text-opacity));
}

.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127, 29, 29, var(--tw-text-opacity));
}

.text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253, 164, 175, var(--tw-text-opacity));
}

.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14, 165, 233, var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255, 255, 255, var(--tw-text-opacity));
}

.text-zinc-800 {
  --tw-text-opacity: 1;
  color: rgb(39, 39, 42, var(--tw-text-opacity));
}

.text-opacity-70 {
  --tw-text-opacity: 0.7;
}

.no-underline {
  text-decoration-line: none;
}

.opacity-0 {
  opacity: 0;
}

.opacity-90 {
  opacity: 0.9;
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_0px_15px_rgba\\(0\\,0\\,0\\,0\\.35\\)\\] {
  --tw-shadow: 0px 0px 15px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0px 0px 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_0px_7px_rgba\\(0\\,0\\,0\\,0\\.4\\)\\] {
  --tw-shadow: 0px 0px 7px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0px 0px 7px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_2px_5px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
  --tw-shadow: 0px 2px 5px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0px 2px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_4px_4px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
  --tw-shadow: 0px 4px 4px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0px 4px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_7px_29px_0px_rgba\\(100\\,100\\,111\\,0\\.2\\)\\] {
  --tw-shadow: 0px 7px 29px 0px rgba(100,100,111,0.2);
  --tw-shadow-colored: 0px 7px 29px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0px_8px_24px_rgba\\(149\\,157\\,165\\,0\\.2\\)\\] {
  --tw-shadow: 0px 8px 24px rgba(149,157,165,0.2);
  --tw-shadow-colored: 0px 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-pink-500\\/50 {
  --tw-shadow-color: rgb(236 72 153 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline {
  outline-style: solid;
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.backdrop-blur-\\[20px\\] {
  --tw-backdrop-blur: blur(20px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

:root {
  --main-color: #f6f2ff;
  --main-deepColor: #cec3e7;
  --primary: #328b94;
  --apple: #f5f5f7;
}

html {
  scroll-behavior: smooth;
}

.saveDefaultButtonStyle {
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: 1s box-shadow;
  cursor: pointer;
  width: 100%;
  min-height: 50px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  border-radius: 85px;
  padding: 0px 10px;
}

.saveDefaultButtonGlowingStyle::before,
.saveDefaultButtonGlowingStyle::after {
  display: block;
  content: "";
  position: absolute;
  width: 65%;
  height: 50px;
  background-color: #00f2ff;
  box-shadow: 1px 1px 15px #00f2ff;
  border-radius: 75px;
  z-index: -1;
  animation: 2s clockwise infinite;
}

.saveDefaultButtonGlowingStyle::after {
  background-color: #ae00ff;
  box-shadow: 1px 1px 15px #ae00ff;
  animation: 2s anticlockwise infinite;
}

@keyframes clockwise {
  0% {
    top: -2px;
    left: 0px;
  }
  12% {
    top: -2px;
    left: 2px;
  }
  25% {
    top: 0;
    left: 5px;
  }
  37% {
    top: 2px;
    left: 2px;
  }
  50% {
    top: 5px;
    left: 0;
  }
  62% {
    top: 2px;
    left: -2px;
  }
  75% {
    top: 0;
    left: -2px;
  }
  87% {
    top: -2px;
    left: -2px;
  }
  100% {
    top: -2px;
    left: 0;
  }
}
@keyframes anticlockwise {
  0% {
    top: -2px;
    right: 0px;
  }
  12% {
    top: -2px;
    right: 2px;
  }
  25% {
    top: 0;
    right: 5px;
  }
  37% {
    top: 2px;
    right: 2px;
  }
  50% {
    top: 5px;
    right: 0;
  }
  62% {
    top: 2px;
    right: -2px;
  }
  75% {
    top: 0;
    right: -2px;
  }
  87% {
    top: -2px;
    right: -2px;
  }
  100% {
    top: -2px;
    right: 0;
  }
}
.hover\\:bg-\\[\\#d9d9d9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217, 217, 217, var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#f5f5f7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245, 245, 247, var(--tw-bg-opacity));
}

.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0, 0, 0, var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243, 244, 246, var(--tw-bg-opacity));
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220, 38, 38, var(--tw-bg-opacity));
}

.hover\\:bg-sky-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240, 249, 255, var(--tw-bg-opacity));
}

.hover\\:bg-gradient-to-br:hover {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.hover\\:bg-gradient-to-l:hover {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}

.hover\\:text-rose-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251, 113, 133, var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255, 255, 255, var(--tw-text-opacity));
}

.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
}

.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}

.focus\\:ring-rose-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity));
}

.focus\\:ring-sky-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.active\\:bg-red-700:active {
  --tw-bg-opacity: 1;
  background-color: rgb(185, 28, 28, var(--tw-bg-opacity));
}

.peer:valid ~ .peer-valid\\:left-\\[10px\\] {
  left: 10px;
}

.peer:valid ~ .peer-valid\\:top-\\[-15px\\] {
  top: -15px;
}

.peer:valid ~ .peer-valid\\:z-\\[1\\] {
  z-index: 1;
}

.peer:valid ~ .peer-valid\\:text-\\[13px\\] {
  font-size: 13px;
}

.peer:focus ~ .peer-focus\\:left-\\[10px\\] {
  left: 10px;
}

.peer:focus ~ .peer-focus\\:top-\\[-15px\\] {
  top: -15px;
}

.peer:focus ~ .peer-focus\\:z-\\[1\\] {
  z-index: 1;
}

.peer:focus ~ .peer-focus\\:text-\\[13px\\] {
  font-size: 13px;
}

@media (min-width: 1024px) {
  .lg\\:flex {
    display: flex;
  }
  .lg\\:hidden {
    display: none;
  }
  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:items-start {
    align-items: flex-start;
  }
  .lg\\:p-\\[100px\\] {
    padding: 100px;
  }
}
@media (prefers-color-scheme: dark) {
  .dark\\:bg-red-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(248, 113, 113, var(--tw-bg-opacity));
  }
  .dark\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255, 255, 255, var(--tw-text-opacity));
  }
  .dark\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  }
  .dark\\:shadow-pink-800\\/80 {
    --tw-shadow-color: rgb(157 23 77 / 0.8);
    --tw-shadow: var(--tw-shadow-colored);
  }
  .dark\\:hover\\:bg-red-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(252, 165, 165, var(--tw-bg-opacity));
  }
  .dark\\:active\\:bg-red-200:active {
    --tw-bg-opacity: 1;
    background-color: rgb(254, 202, 202, var(--tw-bg-opacity));
  }
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./controllers/client/css/tailwind.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,kCAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,kCAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;AACF;;AAEA;;CAAA;AAIA;;;CAAA;AAKA;;;EAGE,sBAAA;EACA,MAAA;EACA,eAAA;EACA,MAAA;EACA,mBAAA;EACA,MAAA;EACA,qBAAA;EACA,MAAA;AADF;;AAIA;;EAEE,gBAAA;AADF;;AAIA;;;;;;;;CAAA;AAUA;;EAEE,gBAAA;EACA,MAAA;EACA,8BAAA;EACA,MAAA;EACA,gBAAA;EACA,MAAA;EACA,cAAA;EACG,WAAA;EACH,MAAA;EACA,+HAAA;EACA,MAAA;EACA,6BAAA;EACA,MAAA;EACA,+BAAA;EACA,MAAA;EACA,wCAAA;EACA,MAAA;AAFF;;AAKA;;;CAAA;AAKA;EACE,SAAA;EACA,MAAA;EACA,oBAAA;EACA,MAAA;AAHF;;AAMA;;;;CAAA;AAMA;EACE,SAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;EACA,qBAAA;EACA,MAAA;AAJF;;AAOA;;CAAA;AAIA;EACE,yCAAA;EACQ,iCAAA;AALV;;AAQA;;CAAA;AAIA;;;;;;EAME,kBAAA;EACA,oBAAA;AANF;;AASA;;CAAA;AAIA;EACE,cAAA;EACA,wBAAA;AAPF;;AAUA;;CAAA;AAIA;;EAEE,mBAAA;AARF;;AAWA;;;;;CAAA;AAOA;;;;EAIE,+GAAA;EACA,MAAA;EACA,6BAAA;EACA,MAAA;EACA,+BAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;AATF;;AAYA;;CAAA;AAIA;EACE,cAAA;AAVF;;AAaA;;CAAA;AAIA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;;;;CAAA;AAMA;EACE,cAAA;EACA,MAAA;EACA,qBAAA;EACA,MAAA;EACA,yBAAA;EACA,MAAA;AAZF;;AAeA;;;;CAAA;AAMA;;;;;EAKE,oBAAA;EACA,MAAA;EACA,8BAAA;EACA,MAAA;EACA,gCAAA;EACA,MAAA;EACA,eAAA;EACA,MAAA;EACA,oBAAA;EACA,MAAA;EACA,oBAAA;EACA,MAAA;EACA,uBAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,MAAA;AAbF;;AAgBA;;CAAA;AAIA;;EAEE,oBAAA;AAdF;;AAiBA;;;CAAA;AAKA;;;;EAIE,0BAAA;EACA,MAAA;EACA,6BAAA;EACA,MAAA;EACA,sBAAA;EACA,MAAA;AAfF;;AAkBA;;CAAA;AAIA;EACE,aAAA;AAhBF;;AAmBA;;CAAA;AAIA;EACE,gBAAA;AAjBF;;AAoBA;;CAAA;AAIA;EACE,wBAAA;AAlBF;;AAqBA;;CAAA;AAIA;;EAEE,YAAA;AAnBF;;AAsBA;;;CAAA;AAKA;EACE,6BAAA;EACA,MAAA;EACA,oBAAA;EACA,MAAA;AApBF;;AAuBA;;CAAA;AAIA;EACE,wBAAA;AArBF;;AAwBA;;;CAAA;AAKA;EACE,0BAAA;EACA,MAAA;EACA,aAAA;EACA,MAAA;AAtBF;;AAyBA;;CAAA;AAIA;EACE,kBAAA;AAvBF;;AA0BA;;CAAA;AAIA;;;;;;;;;;;;;EAaE,SAAA;AAxBF;;AA2BA;EACE,SAAA;EACA,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;;;EAGE,gBAAA;EACA,SAAA;EACA,UAAA;AAxBF;;AA2BA;;CAAA;AAIA;EACE,UAAA;AAzBF;;AA4BA;;CAAA;AAIA;EACE,gBAAA;AA1BF;;AA6BA;;;CAAA;AAKA;EACE,UAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;AA3BF;;AA8BA;;EAEE,UAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;AA3BF;;AA8BA;;CAAA;AAIA;;EAEE,eAAA;AA5BF;;AA+BA;;CAAA;AAIA;EACE,eAAA;AA7BF;;AAgCA;;;;CAAA;AAMA;;;;;;;;EAQE,cAAA;EACA,MAAA;EACA,sBAAA;EACA,MAAA;AA9BF;;AAiCA;;CAAA;AAIA;;EAEE,eAAA;EACA,YAAA;AA/BF;;AAkCA,wEAAA;AAEA;EACE,aAAA;AAhCF;;AAmCA;EACE,sBAAA;AAhCF;;AAmCA;EACE,WAAA;AAhCF;;AAmCA;EACE;IACE,2BAAA;EAhCF;EAmCA;IACE,gBAAA;EAjCF;AACF;AAoCA;EACE;IACE,2BAAA;EAlCF;EAqCA;IACE,gBAAA;EAnCF;AACF;AAsCA;EACE;IACE,4BAAA;EApCF;EAuCA;IACE,iBAAA;EArCF;AACF;AAwCA;EACE;IACE,4BAAA;EAtCF;EAyCA;IACE,iBAAA;EAvCF;AACF;AA0CA;EACE;IACE,4BAAA;EAxCF;EA2CA;IACE,iBAAA;EAzCF;AACF;AA4CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,QAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,QAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,QAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,QAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,2BAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,0BAAA;AA1CF;;AA6CA;EACE,wBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,yBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,wBAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,YAAA;EACA,aAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,wBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,uBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,OAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,+LAAA;AA1CF;;AA6CA;EACE,+LAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,wBAAA;EACG,qBAAA;EACK,gBAAA;AA1CV;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,2BAAA;AA1CF;;AA6CA;EACE,yBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,8BAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,SAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,kCAAA;EACA,iCAAA;AA1CF;;AA6CA;EACE,8BAAA;EACA,+BAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,wBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,yDAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,oDAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,iEAAA;AA1CF;;AA6CA;EACE,6BAAA;EACA,qEAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,uDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,yDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,mDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,8BAAA;AA1CF;;AA6CA;EACE,gCAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,sDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,oDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,yDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,wDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,yDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,wDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,wDAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,0DAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,uDAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,wEAAA;AA1CF;;AA6CA;EACE,yLAAA;AA1CF;;AA6CA;EACE,qEAAA;AA1CF;;AA6CA;EACE,4DAAA;EACA,qEAAA;EACA,mEAAA;AA1CF;;AA6CA;EACE,4DAAA;EACA,qEAAA;EACA,mEAAA;AA1CF;;AA6CA;EACE,4DAAA;EACA,oEAAA;EACA,mEAAA;AA1CF;;AA6CA;EACE,4DAAA;EACA,mEAAA;EACA,mEAAA;AA1CF;;AA6CA;EACE,oEAAA;EACA,4GAAA;AA1CF;;AA6CA;EACE,wDAAA;AA1CF;;AA6CA;EACE,wDAAA;AA1CF;;AA6CA;EACE,wDAAA;AA1CF;;AA6CA;EACE,wDAAA;AA1CF;;AA6CA;EACE,sBAAA;EACG,mBAAA;AA1CL;;AA6CA;EACE,oBAAA;EACG,iBAAA;AA1CL;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,aAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,qBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,qBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,qBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,wBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,wBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,sBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,wBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,uBAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,wBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,uBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,uBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,gBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,mBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,iBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,mBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,oBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,iBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,cAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,qBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,6CAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,2CAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,iDAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,gDAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,+CAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,iDAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,gDAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,iDAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,8CAAA;AA1CF;;AA6CA;EACE,sBAAA;AA1CF;;AA6CA;EACE,0BAAA;AA1CF;;AA6CA;EACE,UAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,0EAAA;EACA,8FAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,gDAAA;EACA,6DAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,0CAAA;EACA,wDAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,wCAAA;EACA,uDAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,yCAAA;EACA,uDAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,yCAAA;EACA,uDAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,mDAAA;EACA,4DAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,+CAAA;EACA,wDAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,+EAAA;EACA,mGAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,6EAAA;EACA,iGAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,gFAAA;EACA,oGAAA;EACA,6HAAA;AA1CF;;AA6CA;EACE,wCAAA;EACA,qCAAA;AA1CF;;AA6CA;EACE,8BAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE,oBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,iLAAA;AA1CF;;AA6CA;EACE,kGAAA;EACA,iLAAA;AA1CF;;AA6CA;EACE,iLAAA;AA1CF;;AA6CA;EACE,8BAAA;EACA,+QAAA;EACA,uQAAA;AA1CF;;AA6CA;EACE,8BAAA;EACA,+QAAA;EACA,uQAAA;AA1CF;;AA6CA;EACE,6BAAA;EACA,+QAAA;EACA,uQAAA;AA1CF;;AA6CA;EACE,+QAAA;EACA,uQAAA;AA1CF;;AA6CA;EACE,gKAAA;EACA,wJAAA;EACA,iLAAA;EACA,wDAAA;EACA,0BAAA;AA1CF;;AA6CA;EACE,wBAAA;EACA,wDAAA;EACA,0BAAA;AA1CF;;AA6CA;EACE,4BAAA;EACA,wDAAA;EACA,0BAAA;AA1CF;;AA6CA;EACE,0BAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,sFAAA;EAEA,mBAAA;EACA,iBAAA;AA3CF;;AA8CA;;EAEE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AA3CF;;AA8CA;EACE,yBAAA;EACA,gCAAA;EACA,oCAAA;AA3CF;;AA8CA;EACE;IACE,SAAA;IACA,SAAA;EA3CF;EA8CA;IACE,SAAA;IACA,SAAA;EA5CF;EA+CA;IACE,MAAA;IACA,SAAA;EA7CF;EAgDA;IACE,QAAA;IACA,SAAA;EA9CF;EAiDA;IACE,QAAA;IACA,OAAA;EA/CF;EAkDA;IACE,QAAA;IACA,UAAA;EAhDF;EAmDA;IACE,MAAA;IACA,UAAA;EAjDF;EAoDA;IACE,SAAA;IACA,UAAA;EAlDF;EAqDA;IACE,SAAA;IACA,OAAA;EAnDF;AACF;AAsDA;EACE;IACE,SAAA;IACA,UAAA;EApDF;EAuDA;IACE,SAAA;IACA,UAAA;EArDF;EAwDA;IACE,MAAA;IACA,UAAA;EAtDF;EAyDA;IACE,QAAA;IACA,UAAA;EAvDF;EA0DA;IACE,QAAA;IACA,QAAA;EAxDF;EA2DA;IACE,QAAA;IACA,WAAA;EAzDF;EA4DA;IACE,MAAA;IACA,WAAA;EA1DF;EA6DA;IACE,SAAA;IACA,WAAA;EA3DF;EA8DA;IACE,SAAA;IACA,QAAA;EA5DF;AACF;AA+DA;EACE,kBAAA;EACA,0DAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,0DAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,oDAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,0DAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,wDAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,0DAAA;AA7DF;;AAgEA;EACE,4EAAA;AA7DF;;AAgEA;EACE,oEAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,iDAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,iDAAA;AA7DF;;AAgEA;EACE,gDAAA;EACA,6DAAA;EACA,6HAAA;AA7DF;;AAgEA;EACE,8BAAA;EACA,mBAAA;AA7DF;;AAgEA;EACE,2GAAA;EACA,yGAAA;EACA,uGAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,wDAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,0DAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,yDAAA;AA7DF;;AAgEA;EACE,2BAAA;AA7DF;;AAgEA;EACE,kBAAA;EACA,wDAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,eAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,UAAA;AA7DF;;AAgEA;EACE,eAAA;AA7DF;;AAgEA;EACE;IACE,aAAA;EA7DF;EAgEA;IACE,aAAA;EA9DF;EAiEA;IACE,UAAA;EA/DF;EAkEA;IACE,mBAAA;EAhEF;EAmEA;IACE,uBAAA;EAjEF;EAoEA;IACE,cAAA;EAlEF;AACF;AAqEA;EACE;IACE,kBAAA;IACA,0DAAA;EAnEF;EAsEA;IACE,oBAAA;IACA,iDAAA;EApEF;EAuEA;IACE,+EAAA;IACA,mGAAA;IACA,6HAAA;EArEF;EAwEA;IACE,uCAAA;IACA,qCAAA;EAtEF;EAyEA;IACE,kBAAA;IACA,0DAAA;EAvEF;EA0EA;IACE,kBAAA;IACA,0DAAA;EAxEF;AACF;AA2EA;EACE,aAAA;AAzEF","sourcesContent":["*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n/*\n! tailwindcss v3.4.13 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n7. Disable tap highlights on iOS\n*/\n\nhtml,\n:host {\n  line-height: 1.5;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4;\n  /* 3 */\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  /* 4 */\n  font-feature-settings: normal;\n  /* 5 */\n  font-variation-settings: normal;\n  /* 6 */\n  -webkit-tap-highlight-color: transparent;\n  /* 7 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0;\n  /* 1 */\n  line-height: inherit;\n  /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  border-top-width: 1px;\n  /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  /* 1 */\n  font-feature-settings: normal;\n  /* 2 */\n  font-variation-settings: normal;\n  /* 3 */\n  font-size: 1em;\n  /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0;\n  /* 1 */\n  border-color: inherit;\n  /* 2 */\n  border-collapse: collapse;\n  /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-feature-settings: inherit;\n  /* 1 */\n  font-variation-settings: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  font-weight: inherit;\n  /* 1 */\n  line-height: inherit;\n  /* 1 */\n  letter-spacing: inherit;\n  /* 1 */\n  color: inherit;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n  padding: 0;\n  /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\ninput:where([type='button']),\ninput:where([type='reset']),\ninput:where([type='submit']) {\n  -webkit-appearance: button;\n  /* 1 */\n  background-color: transparent;\n  /* 2 */\n  background-image: none;\n  /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden] {\n  display: none;\n}\n\n.\\!container {\n  width: 100% !important;\n}\n\n.container {\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .\\!container {\n    max-width: 640px !important;\n  }\n\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .\\!container {\n    max-width: 768px !important;\n  }\n\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .\\!container {\n    max-width: 1024px !important;\n  }\n\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .\\!container {\n    max-width: 1280px !important;\n  }\n\n  .container {\n    max-width: 1280px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .\\!container {\n    max-width: 1536px !important;\n  }\n\n  .container {\n    max-width: 1536px;\n  }\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.static {\n  position: static;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.\\!absolute {\n  position: absolute !important;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.inset-0 {\n  inset: 0px;\n}\n\n.bottom-0 {\n  bottom: 0px;\n}\n\n.bottom-5 {\n  bottom: 1.25rem;\n}\n\n.bottom-\\[-20px\\] {\n  bottom: -20px;\n}\n\n.bottom-\\[-25px\\] {\n  bottom: -25px;\n}\n\n.bottom-\\[-60\\%\\] {\n  bottom: -60%;\n}\n\n.bottom-\\[-70\\%\\] {\n  bottom: -70%;\n}\n\n.bottom-\\[-80\\%\\] {\n  bottom: -80%;\n}\n\n.bottom-\\[1\\.5rem\\] {\n  bottom: 1.5rem;\n}\n\n.bottom-\\[250px\\] {\n  bottom: 250px;\n}\n\n.left-0 {\n  left: 0px;\n}\n\n.left-\\[-10px\\] {\n  left: -10px;\n}\n\n.left-\\[-5px\\] {\n  left: -5px;\n}\n\n.left-\\[-8px\\] {\n  left: -8px;\n}\n\n.left-\\[0\\%\\] {\n  left: 0%;\n}\n\n.left-\\[10\\%\\] {\n  left: 10%;\n}\n\n.left-\\[130px\\] {\n  left: 130px;\n}\n\n.left-\\[150px\\] {\n  left: 150px;\n}\n\n.left-\\[20\\%\\] {\n  left: 20%;\n}\n\n.right-0 {\n  right: 0px;\n}\n\n.right-5 {\n  right: 1.25rem;\n}\n\n.right-\\[-8px\\] {\n  right: -8px;\n}\n\n.right-\\[0\\.5rem\\] {\n  right: 0.5rem;\n}\n\n.right-\\[10px\\] {\n  right: 10px;\n}\n\n.right-\\[200px\\] {\n  right: 200px;\n}\n\n.right-\\[5px\\] {\n  right: 5px;\n}\n\n.top-0 {\n  top: 0px;\n}\n\n.top-\\[-10px\\] {\n  top: -10px;\n}\n\n.top-\\[-20px\\] {\n  top: -20px;\n}\n\n.top-\\[-5px\\] {\n  top: -5px;\n}\n\n.top-\\[-60px\\] {\n  top: -60px;\n}\n\n.top-\\[-8px\\] {\n  top: -8px;\n}\n\n.top-\\[0\\.5rem\\] {\n  top: 0.5rem;\n}\n\n.top-\\[10\\%\\] {\n  top: 10%;\n}\n\n.top-\\[100px\\] {\n  top: 100px;\n}\n\n.top-\\[10px\\] {\n  top: 10px;\n}\n\n.top-\\[110\\%\\] {\n  top: 110%;\n}\n\n.top-\\[20px\\] {\n  top: 20px;\n}\n\n.top-\\[40px\\] {\n  top: 40px;\n}\n\n.top-\\[5px\\] {\n  top: 5px;\n}\n\n.z-0 {\n  z-index: 0;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.z-\\[0\\] {\n  z-index: 0;\n}\n\n.z-\\[10\\] {\n  z-index: 10;\n}\n\n.z-\\[1\\] {\n  z-index: 1;\n}\n\n.z-\\[2\\] {\n  z-index: 2;\n}\n\n.z-\\[999\\] {\n  z-index: 999;\n}\n\n.z-\\[99\\] {\n  z-index: 99;\n}\n\n.m-2\\.5 {\n  margin: 0.625rem;\n}\n\n.m-3 {\n  margin: 0.75rem;\n}\n\n.m-\\[10px\\] {\n  margin: 10px;\n}\n\n.m-\\[15px\\] {\n  margin: 15px;\n}\n\n.m-\\[20px\\] {\n  margin: 20px;\n}\n\n.m-\\[5px\\] {\n  margin: 5px;\n}\n\n.mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.mx-\\[10px\\] {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.mx-\\[15px\\] {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.mx-\\[1rem\\] {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.my-0 {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.my-\\[10px\\] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.my-\\[15px\\] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.my-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.\\!mb-\\[5px\\] {\n  margin-bottom: 5px !important;\n}\n\n.\\!ml-0 {\n  margin-left: 0px !important;\n}\n\n.\\!mr-\\[10px\\] {\n  margin-right: 10px !important;\n}\n\n.\\!mt-0 {\n  margin-top: 0px !important;\n}\n\n.-mb-3\\.5 {\n  margin-bottom: -0.875rem;\n}\n\n.mb-0 {\n  margin-bottom: 0px;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-\\[10px\\] {\n  margin-bottom: 10px;\n}\n\n.mb-\\[15px\\] {\n  margin-bottom: 15px;\n}\n\n.mb-\\[20px\\] {\n  margin-bottom: 20px;\n}\n\n.mb-\\[40px\\] {\n  margin-bottom: 40px;\n}\n\n.me-2 {\n  margin-inline-end: 0.5rem;\n}\n\n.ml-\\[40px\\] {\n  margin-left: 40px;\n}\n\n.ml-\\[5px\\] {\n  margin-left: 5px;\n}\n\n.mr-14 {\n  margin-right: 3.5rem;\n}\n\n.mr-\\[10px\\] {\n  margin-right: 10px;\n}\n\n.mr-\\[5px\\] {\n  margin-right: 5px;\n}\n\n.mt-0 {\n  margin-top: 0px;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.mt-1\\.5 {\n  margin-top: 0.375rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-2\\.5 {\n  margin-top: 0.625rem;\n}\n\n.mt-3 {\n  margin-top: 0.75rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mt-5 {\n  margin-top: 1.25rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mt-7 {\n  margin-top: 1.75rem;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n.mt-\\[10px\\] {\n  margin-top: 10px;\n}\n\n.mt-\\[20px\\] {\n  margin-top: 20px;\n}\n\n.mt-\\[30px\\] {\n  margin-top: 30px;\n}\n\n.block {\n  display: block;\n}\n\n.\\!flex {\n  display: flex !important;\n}\n\n.flex {\n  display: flex;\n}\n\n.table {\n  display: table;\n}\n\n.hidden {\n  display: none;\n}\n\n.aspect-\\[0\\.924\\] {\n  aspect-ratio: 0.924;\n}\n\n.aspect-\\[0\\.97\\] {\n  aspect-ratio: 0.97;\n}\n\n.aspect-\\[1\\.02\\] {\n  aspect-ratio: 1.02;\n}\n\n.aspect-\\[1\\.03\\] {\n  aspect-ratio: 1.03;\n}\n\n.aspect-\\[1\\.161\\] {\n  aspect-ratio: 1.161;\n}\n\n.aspect-\\[1\\.81\\] {\n  aspect-ratio: 1.81;\n}\n\n.aspect-\\[1\\.871\\] {\n  aspect-ratio: 1.871;\n}\n\n.aspect-\\[1\\/2\\] {\n  aspect-ratio: 1/2;\n}\n\n.aspect-\\[3\\.44\\] {\n  aspect-ratio: 3.44;\n}\n\n.aspect-\\[3\\.69\\] {\n  aspect-ratio: 3.69;\n}\n\n.aspect-\\[5\\.52\\] {\n  aspect-ratio: 5.52;\n}\n\n.aspect-square {\n  aspect-ratio: 1 / 1;\n}\n\n.size-\\[150px\\] {\n  width: 150px;\n  height: 150px;\n}\n\n.size-\\[40px\\] {\n  width: 40px;\n  height: 40px;\n}\n\n.size-\\[50px\\] {\n  width: 50px;\n  height: 50px;\n}\n\n.size-full {\n  width: 100%;\n  height: 100%;\n}\n\n.h-0\\.5 {\n  height: 0.125rem;\n}\n\n.h-3 {\n  height: 0.75rem;\n}\n\n.h-\\[100dvh\\] {\n  height: 100dvh;\n}\n\n.h-\\[100px\\] {\n  height: 100px;\n}\n\n.h-\\[100vh\\] {\n  height: 100vh;\n}\n\n.h-\\[10px\\] {\n  height: 10px;\n}\n\n.h-\\[150px\\] {\n  height: 150px;\n}\n\n.h-\\[16px\\] {\n  height: 16px;\n}\n\n.h-\\[1px\\] {\n  height: 1px;\n}\n\n.h-\\[25px\\] {\n  height: 25px;\n}\n\n.h-\\[320px\\] {\n  height: 320px;\n}\n\n.h-\\[32px\\] {\n  height: 32px;\n}\n\n.h-\\[400px\\] {\n  height: 400px;\n}\n\n.h-\\[40px\\] {\n  height: 40px;\n}\n\n.h-\\[500\\%\\] {\n  height: 500%;\n}\n\n.h-\\[500px\\] {\n  height: 500px;\n}\n\n.h-\\[50px\\] {\n  height: 50px;\n}\n\n.h-\\[70\\%\\] {\n  height: 70%;\n}\n\n.h-\\[700px\\] {\n  height: 700px;\n}\n\n.h-\\[70px\\] {\n  height: 70px;\n}\n\n.h-\\[70vh\\] {\n  height: 70vh;\n}\n\n.h-\\[75vh\\] {\n  height: 75vh;\n}\n\n.h-\\[800px\\] {\n  height: 800px;\n}\n\n.h-\\[90\\%\\] {\n  height: 90%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-fit {\n  height: -moz-fit-content;\n  height: fit-content;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-screen {\n  height: 100vh;\n}\n\n.max-h-\\[500px\\] {\n  max-height: 500px;\n}\n\n.max-h-\\[700px\\] {\n  max-height: 700px;\n}\n\n.min-h-\\[141px\\] {\n  min-height: 141px;\n}\n\n.min-h-\\[179px\\] {\n  min-height: 179px;\n}\n\n.min-h-\\[200px\\] {\n  min-height: 200px;\n}\n\n.min-h-\\[248px\\] {\n  min-height: 248px;\n}\n\n.min-h-\\[660px\\] {\n  min-height: 660px;\n}\n\n.\\!w-\\[20px\\] {\n  width: 20px !important;\n}\n\n.w-10 {\n  width: 2.5rem;\n}\n\n.w-\\[100\\%\\] {\n  width: 100%;\n}\n\n.w-\\[100px\\] {\n  width: 100px;\n}\n\n.w-\\[10rem\\] {\n  width: 10rem;\n}\n\n.w-\\[125px\\] {\n  width: 125px;\n}\n\n.w-\\[134px\\] {\n  width: 134px;\n}\n\n.w-\\[150px\\] {\n  width: 150px;\n}\n\n.w-\\[16px\\] {\n  width: 16px;\n}\n\n.w-\\[20\\%\\] {\n  width: 20%;\n}\n\n.w-\\[200px\\] {\n  width: 200px;\n}\n\n.w-\\[240px\\] {\n  width: 240px;\n}\n\n.w-\\[242px\\] {\n  width: 242px;\n}\n\n.w-\\[25px\\] {\n  width: 25px;\n}\n\n.w-\\[300px\\] {\n  width: 300px;\n}\n\n.w-\\[330px\\] {\n  width: 330px;\n}\n\n.w-\\[332px\\] {\n  width: 332px;\n}\n\n.w-\\[345px\\] {\n  width: 345px;\n}\n\n.w-\\[34px\\] {\n  width: 34px;\n}\n\n.w-\\[354px\\] {\n  width: 354px;\n}\n\n.w-\\[35px\\] {\n  width: 35px;\n}\n\n.w-\\[37px\\] {\n  width: 37px;\n}\n\n.w-\\[38\\.95vh\\] {\n  width: 38.95vh;\n}\n\n.w-\\[38px\\] {\n  width: 38px;\n}\n\n.w-\\[40\\%\\] {\n  width: 40%;\n}\n\n.w-\\[40px\\] {\n  width: 40px;\n}\n\n.w-\\[41px\\] {\n  width: 41px;\n}\n\n.w-\\[45px\\] {\n  width: 45px;\n}\n\n.w-\\[46px\\] {\n  width: 46px;\n}\n\n.w-\\[50\\%\\] {\n  width: 50%;\n}\n\n.w-\\[50px\\] {\n  width: 50px;\n}\n\n.w-\\[60\\%\\] {\n  width: 60%;\n}\n\n.w-\\[60px\\] {\n  width: 60px;\n}\n\n.w-\\[60vw\\] {\n  width: 60vw;\n}\n\n.w-\\[80\\%\\] {\n  width: 80%;\n}\n\n.w-fit {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-screen {\n  width: 100vw;\n}\n\n.min-w-\\[70\\%\\] {\n  min-width: 70%;\n}\n\n.max-w-\\[1000px\\] {\n  max-width: 1000px;\n}\n\n.max-w-\\[1020px\\] {\n  max-width: 1020px;\n}\n\n.max-w-\\[1500px\\] {\n  max-width: 1500px;\n}\n\n.max-w-\\[300px\\] {\n  max-width: 300px;\n}\n\n.max-w-\\[324px\\] {\n  max-width: 324px;\n}\n\n.max-w-\\[330px\\] {\n  max-width: 330px;\n}\n\n.max-w-\\[354px\\] {\n  max-width: 354px;\n}\n\n.max-w-\\[362px\\] {\n  max-width: 362px;\n}\n\n.max-w-\\[375px\\] {\n  max-width: 375px;\n}\n\n.max-w-\\[381px\\] {\n  max-width: 381px;\n}\n\n.max-w-\\[400px\\] {\n  max-width: 400px;\n}\n\n.max-w-\\[414px\\] {\n  max-width: 414px;\n}\n\n.max-w-\\[430px\\] {\n  max-width: 430px;\n}\n\n.max-w-\\[455px\\] {\n  max-width: 455px;\n}\n\n.max-w-\\[500px\\] {\n  max-width: 500px;\n}\n\n.max-w-\\[600px\\] {\n  max-width: 600px;\n}\n\n.max-w-\\[700px\\] {\n  max-width: 700px;\n}\n\n.max-w-\\[800px\\] {\n  max-width: 800px;\n}\n\n.max-w-\\[90\\%\\] {\n  max-width: 90%;\n}\n\n.max-w-full {\n  max-width: 100%;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-\\[2\\] {\n  flex: 2;\n}\n\n.flex-shrink {\n  flex-shrink: 1;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.shrink-0 {\n  flex-shrink: 0;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n.basis-0 {\n  flex-basis: 0px;\n}\n\n.basis-auto {\n  flex-basis: auto;\n}\n\n.-rotate-90 {\n  --tw-rotate: -90deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.resize {\n  resize: both;\n}\n\n.appearance-none {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.content-center {\n  align-content: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-evenly {\n  justify-content: space-evenly;\n}\n\n.gap-1 {\n  gap: 0.25rem;\n}\n\n.gap-10 {\n  gap: 2.5rem;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-3 {\n  gap: 0.75rem;\n}\n\n.gap-3\\.5 {\n  gap: 0.875rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.gap-5 {\n  gap: 1.25rem;\n}\n\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.gap-7 {\n  gap: 1.75rem;\n}\n\n.gap-8 {\n  gap: 2rem;\n}\n\n.gap-9 {\n  gap: 2.25rem;\n}\n\n.gap-\\[10px\\] {\n  gap: 10px;\n}\n\n.gap-\\[20px\\] {\n  gap: 20px;\n}\n\n.self-center {\n  align-self: center;\n}\n\n.self-stretch {\n  align-self: stretch;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n\n.text-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.rounded-2xl {\n  border-radius: 1rem;\n}\n\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n\n.rounded-\\[10px\\] {\n  border-radius: 10px;\n}\n\n.rounded-\\[20px\\] {\n  border-radius: 20px;\n}\n\n.rounded-\\[25px\\] {\n  border-radius: 25px;\n}\n\n.rounded-\\[29px\\] {\n  border-radius: 29px;\n}\n\n.rounded-\\[2rem\\] {\n  border-radius: 2rem;\n}\n\n.rounded-\\[30px\\] {\n  border-radius: 30px;\n}\n\n.rounded-\\[40px\\] {\n  border-radius: 40px;\n}\n\n.rounded-\\[50\\%\\] {\n  border-radius: 50%;\n}\n\n.rounded-\\[50px\\] {\n  border-radius: 50px;\n}\n\n.rounded-\\[85px\\] {\n  border-radius: 85px;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-none {\n  border-radius: 0px;\n}\n\n.rounded-sm {\n  border-radius: 0.125rem;\n}\n\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n\n.rounded-b-3xl {\n  border-bottom-right-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n}\n\n.rounded-t-3xl {\n  border-top-left-radius: 1.5rem;\n  border-top-right-radius: 1.5rem;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-4 {\n  border-width: 4px;\n}\n\n.border-\\[1px\\] {\n  border-width: 1px;\n}\n\n.border-\\[2px\\] {\n  border-width: 2px;\n}\n\n.border-\\[3px\\] {\n  border-width: 3px;\n}\n\n.border-\\[4px\\] {\n  border-width: 4px;\n}\n\n.border-\\[5px\\] {\n  border-width: 5px;\n}\n\n.border-b-\\[1px\\] {\n  border-bottom-width: 1px;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.border-dashed {\n  border-style: dashed;\n}\n\n.border-none {\n  border-style: none;\n}\n\n.border-\\[\\#ec4899\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(236 72 153 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#f0f0f0\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(240 240 240 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#f472b6\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(244 114 182 / var(--tw-border-opacity));\n}\n\n.border-black {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n\n.border-rose-300 {\n  --tw-border-opacity: 1;\n  border-color: rgb(253 164 175 / var(--tw-border-opacity));\n}\n\n.border-white {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.border-b-white {\n  --tw-border-opacity: 1;\n  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.\\!bg-\\[\\#f0f0f0\\] {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(240 240 240 / var(--tw-bg-opacity)) !important;\n}\n\n.bg-\\[\\#111113\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(17 17 19 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#5eb2e5\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(94 178 229 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#89e6c9\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(137 230 201 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#c3e676\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(195 230 118 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#d4d4d4\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(212 212 212 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#d9ad89\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(217 173 137 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#f0f0f0\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(240 240 240 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#f0f0f0f0\\] {\n  background-color: #f0f0f0f0;\n}\n\n.bg-\\[\\#f3effb\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 239 251 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#f5f5f7\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 247 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#f6cdd2\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(246 205 210 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#fee0e0\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 224 224 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#fff\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-\\[--apple\\] {\n  background-color: var(--apple);\n}\n\n.bg-\\[--primary\\] {\n  background-color: var(--primary);\n}\n\n.bg-\\[red\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 0 0 / var(--tw-bg-opacity));\n}\n\n.bg-black {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\n}\n\n.bg-fuchsia-300 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(240 171 252 / var(--tw-bg-opacity));\n}\n\n.bg-indigo-400 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(129 140 248 / var(--tw-bg-opacity));\n}\n\n.bg-orange-400 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(251 146 60 / var(--tw-bg-opacity));\n}\n\n.bg-orange-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(234 88 12 / var(--tw-bg-opacity));\n}\n\n.bg-pink-500 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(236 72 153 / var(--tw-bg-opacity));\n}\n\n.bg-red-400 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(248 113 113 / var(--tw-bg-opacity));\n}\n\n.bg-red-500 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity));\n}\n\n.bg-red-900 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(127 29 29 / var(--tw-bg-opacity));\n}\n\n.bg-rose-300 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(253 164 175 / var(--tw-bg-opacity));\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-yellow-100 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 249 195 / var(--tw-bg-opacity));\n}\n\n.bg-zinc-800 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(39 39 42 / var(--tw-bg-opacity));\n}\n\n.bg-opacity-90 {\n  --tw-bg-opacity: 0.9;\n}\n\n.bg-\\[linear-gradient\\(269deg\\2c \\#FFDBFF_0\\.77\\%\\2c \\#B1C6FE_99\\.23\\%\\)\\] {\n  background-image: linear-gradient(269deg,#FFDBFF 0.77%,#B1C6FE 99.23%);\n}\n\n.bg-\\[linear-gradient\\(to_right\\2c _hsl\\(0\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(60\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(120\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(180\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(240\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(300\\2c _100\\%\\2c _50\\%\\)\\2c _hsl\\(360\\2c _100\\%\\2c _50\\%\\)\\)\\] {\n  background-image: linear-gradient(to right, hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%), hsl(180, 100%, 50%), hsl(240, 100%, 50%), hsl(300, 100%, 50%), hsl(360, 100%, 50%));\n}\n\n.bg-gradient-to-r {\n  background-image: linear-gradient(to right, var(--tw-gradient-stops));\n}\n\n.from-\\[\\#C8F8FF\\] {\n  --tw-gradient-from: #C8F8FF var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(200 248 255 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.from-pink-400 {\n  --tw-gradient-from: #f472b6 var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.from-purple-500 {\n  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.from-red-500 {\n  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.via-pink-500 {\n  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);\n}\n\n.to-\\[\\#FFD18C\\] {\n  --tw-gradient-to: #FFD18C var(--tw-gradient-to-position);\n}\n\n.to-pink-500 {\n  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);\n}\n\n.to-pink-600 {\n  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);\n}\n\n.to-purple-500 {\n  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);\n}\n\n.object-contain {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n.object-cover {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.p-0 {\n  padding: 0px;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-1\\.5 {\n  padding: 0.375rem;\n}\n\n.p-10 {\n  padding: 2.5rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.p-5 {\n  padding: 1.25rem;\n}\n\n.p-6 {\n  padding: 1.5rem;\n}\n\n.p-\\[10px\\] {\n  padding: 10px;\n}\n\n.p-\\[15px\\] {\n  padding: 15px;\n}\n\n.p-\\[20px\\] {\n  padding: 20px;\n}\n\n.p-\\[2px\\] {\n  padding: 2px;\n}\n\n.p-\\[2rem\\] {\n  padding: 2rem;\n}\n\n.p-\\[30px\\] {\n  padding: 30px;\n}\n\n.p-\\[3px\\] {\n  padding: 3px;\n}\n\n.p-\\[40px\\] {\n  padding: 40px;\n}\n\n.p-\\[50px\\] {\n  padding: 50px;\n}\n\n.p-\\[5px\\] {\n  padding: 5px;\n}\n\n.p-\\[6px\\] {\n  padding: 6px;\n}\n\n.p-\\[8px\\] {\n  padding: 8px;\n}\n\n.px-0 {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n\n.px-14 {\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n}\n\n.px-16 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n\n.px-20 {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.px-7 {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.px-9 {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n\n.px-\\[10px\\] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.px-\\[15px\\] {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.px-\\[20px\\] {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.px-\\[30px\\] {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.px-\\[5px\\] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.py-0 {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.py-0\\.5 {\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n}\n\n.py-1\\.5 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.py-2\\.5 {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.py-3\\.5 {\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n}\n\n.py-5 {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.py-7 {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\n.py-\\[20px\\] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.py-\\[30px\\] {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.py-\\[5px\\] {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.pb-16 {\n  padding-bottom: 4rem;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.pb-4 {\n  padding-bottom: 1rem;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem;\n}\n\n.pl-20 {\n  padding-left: 5rem;\n}\n\n.pl-\\[15px\\] {\n  padding-left: 15px;\n}\n\n.pr-5 {\n  padding-right: 1.25rem;\n}\n\n.pt-10 {\n  padding-top: 2.5rem;\n}\n\n.pt-11 {\n  padding-top: 2.75rem;\n}\n\n.pt-12 {\n  padding-top: 3rem;\n}\n\n.pt-2\\.5 {\n  padding-top: 0.625rem;\n}\n\n.pt-20 {\n  padding-top: 5rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.pt-5 {\n  padding-top: 1.25rem;\n}\n\n.pt-6 {\n  padding-top: 1.5rem;\n}\n\n.pt-\\[15px\\] {\n  padding-top: 15px;\n}\n\n.pt-\\[25px\\] {\n  padding-top: 25px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-4xl {\n  font-size: 2.25rem;\n  line-height: 2.5rem;\n}\n\n.text-5xl {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.text-\\[0\\.8rem\\] {\n  font-size: 0.8rem;\n}\n\n.text-\\[10px\\] {\n  font-size: 10px;\n}\n\n.text-\\[12px\\] {\n  font-size: 12px;\n}\n\n.text-\\[13px\\] {\n  font-size: 13px;\n}\n\n.text-\\[15px\\] {\n  font-size: 15px;\n}\n\n.text-\\[16px\\] {\n  font-size: 16px;\n}\n\n.text-\\[20px\\] {\n  font-size: 20px;\n}\n\n.text-\\[24px\\] {\n  font-size: 24px;\n}\n\n.text-\\[25px\\] {\n  font-size: 25px;\n}\n\n.text-\\[30px\\] {\n  font-size: 30px;\n}\n\n.text-\\[32px\\] {\n  font-size: 32px;\n}\n\n.text-\\[40px\\] {\n  font-size: 40px;\n}\n\n.text-\\[50px\\] {\n  font-size: 50px;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.font-black {\n  font-weight: 900;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-extrabold {\n  font-weight: 800;\n}\n\n.font-extralight {\n  font-weight: 200;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.leading-5 {\n  line-height: 1.25rem;\n}\n\n.leading-none {\n  line-height: 1;\n}\n\n.tracking-wider {\n  letter-spacing: 0.05em;\n}\n\n.tracking-widest {\n  letter-spacing: 0.1em;\n}\n\n.text-\\[red\\] {\n  --tw-text-opacity: 1;\n  color: rgb(255 0 0 / var(--tw-text-opacity));\n}\n\n.text-black {\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n\n.text-pink-400 {\n  --tw-text-opacity: 1;\n  color: rgb(244 114 182 / var(--tw-text-opacity));\n}\n\n.text-pink-500 {\n  --tw-text-opacity: 1;\n  color: rgb(236 72 153 / var(--tw-text-opacity));\n}\n\n.text-red-900 {\n  --tw-text-opacity: 1;\n  color: rgb(127 29 29 / var(--tw-text-opacity));\n}\n\n.text-rose-300 {\n  --tw-text-opacity: 1;\n  color: rgb(253 164 175 / var(--tw-text-opacity));\n}\n\n.text-sky-500 {\n  --tw-text-opacity: 1;\n  color: rgb(14 165 233 / var(--tw-text-opacity));\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.text-zinc-800 {\n  --tw-text-opacity: 1;\n  color: rgb(39 39 42 / var(--tw-text-opacity));\n}\n\n.text-opacity-70 {\n  --tw-text-opacity: 0.7;\n}\n\n.no-underline {\n  text-decoration-line: none;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.opacity-90 {\n  opacity: 0.9;\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-2xl {\n  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_0px_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {\n  --tw-shadow: 0px 0px 15px rgba(0,0,0,0.35);\n  --tw-shadow-colored: 0px 0px 15px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_0px_7px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\] {\n  --tw-shadow: 0px 0px 7px rgba(0,0,0,0.4);\n  --tw-shadow-colored: 0px 0px 7px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_2px_5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {\n  --tw-shadow: 0px 2px 5px rgba(0,0,0,0.25);\n  --tw-shadow-colored: 0px 2px 5px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_4px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {\n  --tw-shadow: 0px 4px 4px rgba(0,0,0,0.25);\n  --tw-shadow-colored: 0px 4px 4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_7px_29px_0px_rgba\\(100\\2c 100\\2c 111\\2c 0\\.2\\)\\] {\n  --tw-shadow: 0px 7px 29px 0px rgba(100,100,111,0.2);\n  --tw-shadow-colored: 0px 7px 29px 0px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-\\[0px_8px_24px_rgba\\(149\\2c 157\\2c 165\\2c 0\\.2\\)\\] {\n  --tw-shadow: 0px 8px 24px rgba(149,157,165,0.2);\n  --tw-shadow-colored: 0px 8px 24px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-md {\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-pink-500\\/50 {\n  --tw-shadow-color: rgb(236 72 153 / 0.5);\n  --tw-shadow: var(--tw-shadow-colored);\n}\n\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.outline {\n  outline-style: solid;\n}\n\n.blur {\n  --tw-blur: blur(8px);\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.drop-shadow {\n  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.backdrop-blur-\\[20px\\] {\n  --tw-backdrop-blur: blur(20px);\n  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n}\n\n.backdrop-blur-lg {\n  --tw-backdrop-blur: blur(16px);\n  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n}\n\n.backdrop-blur-sm {\n  --tw-backdrop-blur: blur(4px);\n  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n}\n\n.backdrop-filter {\n  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-opacity {\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.duration-200 {\n  transition-duration: 200ms;\n}\n\n:root {\n  --main-color: #f6f2ff;\n  --main-deepColor: #cec3e7;\n  --primary: #328b94;\n  --apple: #f5f5f7;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n.saveDefaultButtonStyle {\n  color: black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: 1s box-shadow;\n  cursor: pointer;\n  width: 100%;\n  min-height: 50px;\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,\n    rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\n  border-radius: 85px;\n  padding: 0px 10px;\n}\n\n.saveDefaultButtonGlowingStyle::before,\n.saveDefaultButtonGlowingStyle::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  width: 65%;\n  height: 50px;\n  background-color: #00f2ff;\n  box-shadow: 1px 1px 15px #00f2ff;\n  border-radius: 75px;\n  z-index: -1;\n  animation: 2s clockwise infinite;\n}\n\n.saveDefaultButtonGlowingStyle::after {\n  background-color: #ae00ff;\n  box-shadow: 1px 1px 15px #ae00ff;\n  animation: 2s anticlockwise infinite;\n}\n\n@keyframes clockwise {\n  0% {\n    top: -2px;\n    left: 0px;\n  }\n\n  12% {\n    top: -2px;\n    left: 2px;\n  }\n\n  25% {\n    top: 0;\n    left: 5px;\n  }\n\n  37% {\n    top: 2px;\n    left: 2px;\n  }\n\n  50% {\n    top: 5px;\n    left: 0;\n  }\n\n  62% {\n    top: 2px;\n    left: -2px;\n  }\n\n  75% {\n    top: 0;\n    left: -2px;\n  }\n\n  87% {\n    top: -2px;\n    left: -2px;\n  }\n\n  100% {\n    top: -2px;\n    left: 0;\n  }\n}\n\n@keyframes anticlockwise {\n  0% {\n    top: -2px;\n    right: 0px;\n  }\n\n  12% {\n    top: -2px;\n    right: 2px;\n  }\n\n  25% {\n    top: 0;\n    right: 5px;\n  }\n\n  37% {\n    top: 2px;\n    right: 2px;\n  }\n\n  50% {\n    top: 5px;\n    right: 0;\n  }\n\n  62% {\n    top: 2px;\n    right: -2px;\n  }\n\n  75% {\n    top: 0;\n    right: -2px;\n  }\n\n  87% {\n    top: -2px;\n    right: -2px;\n  }\n\n  100% {\n    top: -2px;\n    right: 0;\n  }\n}\n\n.hover\\:bg-\\[\\#d9d9d9\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(217 217 217 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-\\[\\#f5f5f7\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 247 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-black:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-gray-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-red-600:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(220 38 38 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-sky-50:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(240 249 255 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-gradient-to-br:hover {\n  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));\n}\n\n.hover\\:bg-gradient-to-l:hover {\n  background-image: linear-gradient(to left, var(--tw-gradient-stops));\n}\n\n.hover\\:text-rose-400:hover {\n  --tw-text-opacity: 1;\n  color: rgb(251 113 133 / var(--tw-text-opacity));\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.hover\\:shadow-2xl:hover {\n  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:ring-2:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-red-500:focus {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));\n}\n\n.focus\\:ring-rose-300:focus {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity));\n}\n\n.focus\\:ring-sky-500:focus {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity));\n}\n\n.focus\\:ring-offset-2:focus {\n  --tw-ring-offset-width: 2px;\n}\n\n.active\\:bg-red-700:active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(185 28 28 / var(--tw-bg-opacity));\n}\n\n.peer:valid ~ .peer-valid\\:left-\\[10px\\] {\n  left: 10px;\n}\n\n.peer:valid ~ .peer-valid\\:top-\\[-15px\\] {\n  top: -15px;\n}\n\n.peer:valid ~ .peer-valid\\:z-\\[1\\] {\n  z-index: 1;\n}\n\n.peer:valid ~ .peer-valid\\:text-\\[13px\\] {\n  font-size: 13px;\n}\n\n.peer:focus ~ .peer-focus\\:left-\\[10px\\] {\n  left: 10px;\n}\n\n.peer:focus ~ .peer-focus\\:top-\\[-15px\\] {\n  top: -15px;\n}\n\n.peer:focus ~ .peer-focus\\:z-\\[1\\] {\n  z-index: 1;\n}\n\n.peer:focus ~ .peer-focus\\:text-\\[13px\\] {\n  font-size: 13px;\n}\n\n@media (min-width: 1024px) {\n  .lg\\:flex {\n    display: flex;\n  }\n\n  .lg\\:hidden {\n    display: none;\n  }\n\n  .lg\\:w-\\[70\\%\\] {\n    width: 70%;\n  }\n\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n\n  .lg\\:items-start {\n    align-items: flex-start;\n  }\n\n  .lg\\:p-\\[100px\\] {\n    padding: 100px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .dark\\:bg-red-400 {\n    --tw-bg-opacity: 1;\n    background-color: rgb(248 113 113 / var(--tw-bg-opacity));\n  }\n\n  .dark\\:text-white {\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255 / var(--tw-text-opacity));\n  }\n\n  .dark\\:shadow-lg {\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  }\n\n  .dark\\:shadow-pink-800\\/80 {\n    --tw-shadow-color: rgb(157 23 77 / 0.8);\n    --tw-shadow: var(--tw-shadow-colored);\n  }\n\n  .dark\\:hover\\:bg-red-300:hover {\n    --tw-bg-opacity: 1;\n    background-color: rgb(252 165 165 / var(--tw-bg-opacity));\n  }\n\n  .dark\\:active\\:bg-red-200:active {\n    --tw-bg-opacity: 1;\n    background-color: rgb(254 202 202 / var(--tw-bg-opacity));\n  }\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
